import { Controller } from '@hotwired/stimulus';
import CurrentPage from '@frontend/app/features/CurrentPage';
import WindowEnv from '@frontend/app/features/WindowEnv';
import { displayNone, displayReset, toggleVisiblity } from '@frontend/utils/dom';
import { dispatchCustomEvent } from '@frontend/utils/events';

export default class extends Controller {
  static values = {
    hasAudio: { type: Boolean, default: false },
    isAudioPlaying: { type: Boolean, default: false },
    activeTab: { type: String, default: null },
  }

  static targets = [
    'tabBar',
    'tabButton',
    'readingTabButton',
    'listeningTabButton',
    'visibleWhenReading',
    'visibleWhenListening',
    'speakerIcon',
  ];

  connect() {
    if (WindowEnv.isWithinPodcastApp()) {
      this.hasAudioValue = false;
    }

    if (CurrentPage.hasHash('hoeren')) {
      this.activeTabValue = 'hoeren';
    } else {
      this.activeTabValue = 'lesen';
    }

    document.addEventListener(
      'audio-player:playing',
      this.handleAudioPlaying.bind(this)
    );
    document.addEventListener(
      'audio-player:stopped',
      this.handleAudioStopped.bind(this)
    );
  }

  hasAudioValueChanged() {
    toggleVisiblity(this.tabBarTarget, this.hasAudioValue);
  }

  isAudioPlayingValueChanged() {
    if(this.isAudioPlayingValue) {
      displayReset(this.speakerIconTarget);
    } else {
      displayNone(this.speakerIconTarget);
    }
  }

  activeTabValueChanged() {
    CurrentPage.setHash(this.activeTabValue);

    if(this.activeTabValue === 'lesen') {
      this.setTabActive(this.readingTabButtonTarget);
      this.visibleWhenListeningTargets.forEach((element) => displayNone(element));
      this.visibleWhenReadingTargets.forEach((element) => displayReset(element));
    } else {
      this.setTabActive(this.listeningTabButtonTarget);
      this.visibleWhenReadingTargets.forEach((element) => displayNone(element));
      this.visibleWhenListeningTargets.forEach((element) =>
        displayReset(element)
      );
    }

    dispatchCustomEvent("article-reading-progress:update");
  }

  openReadingTab() {
    this.activeTabValue = 'lesen';
  }

  openListeningTab() {
    this.activeTabValue = 'hoeren';
  }

  setTabActive(activeTabElement) {
    this.tabButtonTargets.forEach((element) =>
      element.classList.remove('is-active')
    );
    activeTabElement.classList.add('is-active');
  }

  handleAudioPlaying() {
    this.isAudioPlayingValue = true;
  }

  handleAudioStopped() {
    this.isAudioPlayingValue = false;
  }
}
